import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import { StoreHandlerProps } from "@store/Store/HandlerCreator";

type Parameter = {
    firstName?: string;
    lastName?: string;
    preferredDefaultLanguage?: string;
};

type Props = StoreHandlerProps & {
    firstNameErrorMessage?: string;
    lastNameErrorMessage?: string;
};

type HandlerType = Handler<Parameter, Props>;

export const ValidateFirstName: HandlerType = props => {
    const { parameter: { firstName } } = props;

    if (typeof firstName === "undefined") {
        return;
    }

    props.firstNameErrorMessage = !firstName ? siteMessage("Field_Required", translate("First Name")).toString() : "";
};

export const ValidateLastName: HandlerType = props => {
    const { parameter: { lastName } } = props;

    if (typeof lastName === "undefined") {
        return;
    }
    
    props.lastNameErrorMessage = !lastName ? siteMessage("Field_Required", translate("Last Name")).toString() : "";
};

export const DispatchUpdateAccountSettings: HandlerType = props => {
    const baseEditingAccount = props.getState().pages.accountSettings.editingAccount;

    props.dispatch({
        editingAccount: props.parameter,
        baseEditingAccount,
        firstNameErrorMessage: props.firstNameErrorMessage,
        lastNameErrorMessage: props.lastNameErrorMessage,
        preferredDefaultLanguage: props.parameter.preferredDefaultLanguage,
        type: "Store/Pages/AccountSettings/UpdateAccountSettings",
    });
};

export const chain = [ValidateFirstName, ValidateLastName, DispatchUpdateAccountSettings];

const updateAccountSettings = createHandlerChainRunnerOptionalParameter(chain, {}, "UpdateAccountSettings");
export default updateAccountSettings;
